<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Device Formula">
      <!-- <b-card-text>Device.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Device -->
            <b-col cols="12">
              <b-form-group label="Device" label-for="v-Device">
                <validation-provider #default="{ errors }"  name="Device" rules="required">
                  <v-select id="v-Device" v-model="form.select_1" placeholder="Chose  Device" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="DeviceOptions" :reduce="DeviceOptions => DeviceOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Condition -->
            <b-col cols="12">
              <b-form-group label="Condition" label-for="v-Condition">
                <validation-provider #default="{ errors }"  name="Condition" rules="required">
                  <b-form-input  id="v-Condition" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Condition" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Operator -->
            <b-col cols="12">
              <b-form-group label="Operator" label-for="v-Operator">
                <validation-provider #default="{ errors }"  name="Operator" rules="required">
                  <b-form-input  id="v-Operator" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Operator" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Value -->
            <b-col cols="12">
              <b-form-group label="Value" label-for="v-Value">
                <validation-provider #default="{ errors }"  name="Value" rules="required">
                  <b-form-input  id="v-Value" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Value" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BFormTextarea, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BFormTextarea, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '', text_1: '',text_2: '',text_3: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ DeviceOptions: state => state.device.options })
  },
  created () {
    this.$store.dispatch('device/getAll')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('device/formPostPutFormula', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('device/getByIdFormula', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.device_id
        this.form.text_1 = data.condition
        this.form.text_2 = data.operator
        this.form.text_3 = data.value
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>